import { MutableRefObject, RefObject } from 'react';
import { latLngBounds } from 'leaflet';
import { Box, List, ListItem, ListItemText } from '@mui/material';
import { SearchListItem } from './SearchListItem';
import { emptyListText, searchList } from './style';
import { popupPaddingBottomRight, popupPaddingTopLeft } from '../map-filter/mapFilterConfig';
import { NewSite } from 'src/types/sites/sites';

export const SearchList = ({
  siteData,
  mapRef,
  markersRef,
}: {
  siteData: NewSite[] | [];
  mapRef: RefObject<L.Map>;
  markersRef: MutableRefObject<Set<L.Marker>>;
}) => {
  const handleListItemClick = (item: NewSite) => {
    const map = mapRef.current;
    if (!map || !markersRef?.current) {
      return;
    }

    const currentRef = (() => {
      let foundMarker: L.Marker | undefined;
      markersRef.current.forEach((refItem: any) => {
        if (refItem.options.children.props.site.id === item.id) {
          foundMarker = refItem;
        }
      });
      return foundMarker;
    })();

    if (currentRef) {
      const bounds = latLngBounds(currentRef.getLatLng(), currentRef.getLatLng());

      map.fitBounds(bounds, {
        paddingTopLeft: popupPaddingTopLeft,
        paddingBottomRight: popupPaddingBottomRight,
        animate: false,
        maxZoom: map.getZoom(),
      });

      currentRef.openPopup();
    }
  };

  return (
    <List sx={searchList}>
      {siteData?.length ? (
        siteData?.map((item) => (
          <Box key={item.id} onClick={() => handleListItemClick(item)}>
            <SearchListItem item={item} />
          </Box>
        ))
      ) : (
        <ListItem disablePadding>
          <ListItemText sx={emptyListText} primary="No Results" />
        </ListItem>
      )}
    </List>
  );
};
